/**
 * 슬라이더 관리 서비스
 */

import { apiClient } from '../../../shared/services/api';
import { SliderItem, SliderFormData } from '../types';

export const sliderService = {
  /**
   * 슬라이더 목록 조회
   */
  getSliders: async (): Promise<SliderItem[]> => {
    // API 실제 응답: { data: { sliders: [...] } }
    const response = await apiClient.get<{ data: { sliders: SliderItem[] } }>('/slider');

    // response = { data: { sliders: [...] } }
    // response.data = { sliders: [...] }
    if (response?.data?.sliders && Array.isArray(response.data.sliders)) {
      return response.data.sliders;
    }

    return [];
  },

  /**
   * 슬라이더 생성
   */
  createSlider: async (data: SliderFormData, imageFile?: File): Promise<SliderItem> => {
    const formData = new FormData();

    // 필드 데이터 추가
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('order', data.order.toString());
    formData.append('isActive', data.isActive.toString());

    // 이미지 파일 추가
    if (imageFile) {
      formData.append('imageFile', imageFile);
    }

    const response = await apiClient.post<{ data: SliderItem }>('/slider', formData);
    return response.data;
  },

  /**
   * 슬라이더 수정
   */
  updateSlider: async (id: number, data: SliderFormData, imageFile?: File): Promise<SliderItem> => {
    const formData = new FormData();

    // 필드 데이터 추가
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('order', data.order.toString());
    formData.append('isActive', data.isActive.toString());

    // 이미지 파일 추가
    if (imageFile) {
      formData.append('imageFile', imageFile);
    }

    const response = await apiClient.put<{ data: SliderItem }>(`/slider/${id}`, formData);
    return response.data;
  },

  /**
   * 슬라이더 삭제
   */
  deleteSlider: async (id: number): Promise<void> => {
    await apiClient.delete(`/slider/${id}`);
  },
};
